export default __webpack_public_path__ + "static/media/KFOkCnqEu92Fr1Mu51xFIzIXKMnyrYk.be23fbcb.woff2";